// gc-block-slideshow-slide view.js
console.log('gc-block-slideshow-slide view.js');
function parseObjectPosition(value, size) {
    const percentageMatch = /^\d+(\.\d+)?%$/;
    console.log(`getVisibleImageArea - Parsing object position: value=${value}, size=${size}`);
    if (percentageMatch.test(value)) {
        const result = (parseFloat(value) / 100) * size;
        console.log(`getVisibleImageArea - Percentage parsed: ${result}`);
        return result;
    } else if (value === "top" || value === "left") {
        console.log(`getVisibleImageArea - Matched top/left, returning 0`);
        return 0;
    } else if (value === "bottom" || value === "right") {
        console.log(`getVisibleImageArea - Matched bottom/right, returning ${size}`);
        return size;
    } else if (value === "center") {
        const result = size / 2;
        console.log(`getVisibleImageArea - Matched center, returning ${result}`);
        return result;
    } else {
        const result = parseFloat(value) || 0;
        console.log(`getVisibleImageArea - Parsed numeric value: ${result}`);
        return result;
    }
}

function getVisibleImageArea(img, imageFocusarea) {
    //es. imageFocusarea (percentages)) {x: 0, y: 0, width: 100, height: 100}
    console.log(`getVisibleImageArea - Calculating visible image area for`, img);
    const computedStyle = window.getComputedStyle(img);
    console.log(`getVisibleImageArea - Computed style:`, computedStyle);

    const {
        width: containerWidthStr, 
        height: containerHeightStr, 
        objectFit, 
        objectPosition
    } = computedStyle;

    const imgNaturalWidth = img.naturalWidth;
    const imgNaturalHeight = img.naturalHeight;

    console.log(`getVisibleImageArea - Natural image size: ${imgNaturalWidth}x${imgNaturalHeight}`);

    const containerWidth = parseFloat(containerWidthStr);
    const containerHeight = parseFloat(containerHeightStr);

    console.log(`getVisibleImageArea - Container size: ${containerWidth}x${containerHeight}`);

    const fit = objectFit || "fill";
    const position = objectPosition || "50% 50%";

    console.log(`getVisibleImageArea - Object fit: ${fit}, Object position: ${position}`);

    let renderedImageWidth = imgNaturalWidth;
    let renderedImageHeight = imgNaturalHeight;

    switch (fit) {
        case "fill":
            renderedImageWidth = containerWidth;
            renderedImageHeight = containerHeight;
            console.log(`getVisibleImageArea - Fit fill: size set to ${renderedImageWidth}x${renderedImageHeight}`);
            break;

        case "contain":
        case "scale-down": {
            const scaleContain = Math.min(
                containerWidth / imgNaturalWidth,
                containerHeight / imgNaturalHeight
            );
            renderedImageWidth = imgNaturalWidth * scaleContain;
            renderedImageHeight = imgNaturalHeight * scaleContain;
            console.log(`getVisibleImageArea - Fit contain/scale-down: size set to ${renderedImageWidth}x${renderedImageHeight}`);
            break;
        }

        case "cover": {
            const scaleCover = Math.max(
                containerWidth / imgNaturalWidth,
                containerHeight / imgNaturalHeight
            );
            renderedImageWidth = imgNaturalWidth * scaleCover;
            renderedImageHeight = imgNaturalHeight * scaleCover;
            console.log(`getVisibleImageArea - Fit cover: size set to ${renderedImageWidth}x${renderedImageHeight}`);
            break;
        }

        case "none":
            console.log(`getVisibleImageArea - Fit none: keeping natural size`);
            break;
    }

    const [horizontalOffsetValue, verticalOffsetValue] = position.split(" ");
    const horizontalOffset = parseObjectPosition(horizontalOffsetValue, containerWidth - renderedImageWidth);
    const verticalOffset = parseObjectPosition(verticalOffsetValue, containerHeight - renderedImageHeight);

    console.log(`getVisibleImageArea - Calculated offsets: horizontal=${horizontalOffset}, vertical=${verticalOffset}`);

    let focusArea = null;
    if (imageFocusarea) {
        console.log(`getVisibleImageArea - imageFocusarea:`, imageFocusarea,imgNaturalWidth, imgNaturalHeight, horizontalOffset, verticalOffset);
        focusArea = {
            x: imageFocusarea.x * renderedImageWidth / 100 - horizontalOffset,
            y: imageFocusarea.y * renderedImageHeight / 100 - verticalOffset,
            width: imageFocusarea.width * renderedImageWidth / 100,
            height: imageFocusarea.height * renderedImageHeight / 100
        };
        console.log(`getVisibleImageArea - Calculated focusArea:`, focusArea);
    }

    return {
        renderedImageWidth,
        renderedImageHeight,
        horizontalOffset,
        verticalOffset,
        containerWidth,
        containerHeight,
        focusArea
    };
}

// const imgElement = document.querySelector("img");
// console.log(getVisibleImageArea(imgElement));


document.addEventListener('DOMContentLoaded', () => {
    let slidesTypeImage = document.querySelectorAll('.wp-block-gc-blocks-gc-block-slideshow-slide[data-slide-type="image"]')
    slidesTypeImage.forEach(slideshowSlide => {
        const imageElement = slideshowSlide.querySelector('img');
        console.log("slideshowSlide",slideshowSlide, imageElement);
        if (imageElement) {
            const imageElementOptions = {
                imageFocusarea: imageElement.dataset.imageFocusarea ? JSON.parse(imageElement.dataset.imageFocusarea) : null,
            };
            if(imageElementOptions.imageFocusarea){
                const checkVisibleImageArea = () => {
                    console.log("getVisibleImageArea",getVisibleImageArea(imageElement,imageElementOptions.imageFocusarea));
                }

                slideshowSlide.addEventListener('slideEnter', (event) => {
                    console.log("slideshowSlide slideEnter");
                    if(imageElement.complete) {
                        checkVisibleImageArea();
                    } else {
                        imageElement.addEventListener('load', () => {
                            checkVisibleImageArea();
                        });
                    }
                })
            }
            // imageElement.addEventListener('load', () =>{
            //     slideshowSlide.addEventListener('slideEnter', (event) => {
            //         checkVisibleImageArea()
            //     })
            // } )
            // window.addEventListener('resize', checkVisibleImageArea )
        }
    })
    document.querySelectorAll('.wp-block-gc-blocks-gc-block-slideshow-slide[data-slide-type="video"]').forEach(slideshowSlide => {

        const videoElement = slideshowSlide.querySelector('video');
        if (videoElement) {
            const videoElementOptions = {
                autoplay: videoElement.dataset.videoAutoplay === 'true',
                restart: videoElement.dataset.videoRestart === 'true',
                waitVideoEnd: videoElement.dataset.waitVideoEnd === 'true',
                controls: videoElement.controls,
                loop: videoElement.loop,
                muted: videoElement.muted, // Fixed: Corrected `mute` to `muted`
            };


            slideshowSlide.addEventListener('slideEnter', (event) => {
                console.log('video slideEnter', event);
                const slideshow = event.detail.slideshow;

                if (videoElementOptions.autoplay) {
                    videoElement.play();
                }

                if (videoElementOptions.waitVideoEnd) {
                    let autoplayActive = !!slideshow.autoplayInterval
                    if(autoplayActive){
                        slideshow.stopAutoplay();
                    }
                    // on video end
                    videoElement.addEventListener('ended', () => {
                        if(autoplayActive){
                            slideshow.showNextSlide();
                            slideshow.startAutoplay();
                        }
                    });
                }
               
                if (videoElementOptions.restart) {
                    videoElement.currentTime = 0; 
                }
                if (videoElementOptions.autoplay) {
                    videoElement.play();
                }
            });

            slideshowSlide.addEventListener('slideExit', (event) => {
                console.log('video slideExit', event, videoElement);
                videoElement.pause();
            });
        }
    });
});
